export default "__VITE_ASSET__0da47721__"